import { alucertoBrand } from './alucerto/config';
import { BrandDefinition, BrandKey } from './brand.interface';
import { marcaBlancaGenericoBrand } from './marca_blanca_generico/config';
import { prestappBrand } from './prestapp/config';
import { pymeRuralBrand } from './pyme_rural/config';
import { telepagosBrand } from './telepagos/config';
import { BRAND_THEME_VARIABLE_NAMES } from './theme-variable';

const DEFAULT_BRAND_KEY: BrandKey = 'telepagos';

export const brandRegistry: Record<BrandKey, BrandDefinition> = {
  telepagos: telepagosBrand,
  prestapp: prestappBrand,
  alucerto: alucertoBrand,
  pyme_rural: pymeRuralBrand,
  marca_blanca_generico: marcaBlancaGenericoBrand,
};

export const brandThemeVariableKeys: string[] = [...BRAND_THEME_VARIABLE_NAMES];

export function getDefaultBrandKey(): BrandKey {
  return DEFAULT_BRAND_KEY;
}

export function getBrandDefinition(brandKey: BrandKey): BrandDefinition {
  return brandRegistry[brandKey] ?? brandRegistry[DEFAULT_BRAND_KEY];
}

export function normalizeBrandHost(host: string): string {
  return (host ?? '').trim().toLowerCase().split(':')[0];
}

export function resolveBrandKey(
  host: string,
  brandByHost: Record<string, BrandKey>
): BrandKey {
  const normalizedHost = normalizeBrandHost(host);

  if (!normalizedHost) {
    return DEFAULT_BRAND_KEY;
  }

  return brandByHost[normalizedHost] ?? DEFAULT_BRAND_KEY;
}
